import { createElement, toggleClass, setStyle, getUiRoot } from './dom';
import type { PaintingOverlay, FrameRect } from './types';
import paintingUrl from '../../docs/reference/cornelis-anthonisz-1538.jpg?url';

/* Mounted once, transparent and click-through, so the opacity transition always has a rendered
   starting state and showing or hiding is a synchronous class toggle with nothing deferred. */
export function createPaintingOverlay(): PaintingOverlay {
  const container = createElement('div', 'painting-overlay', getUiRoot());
  const img = createElement('img', undefined, container);
  img.src = paintingUrl;
  img.alt = 'Cornelis Anthonisz 1538 painting of Amsterdam';

  let isVisible = false;

  function setVisible(visible: boolean): void {
    isVisible = visible;
    toggleClass(container, 'visible', visible);
  }

  function layout(rect: FrameRect): void {
    setStyle(container, 'left', `${rect.x}px`);
    setStyle(container, 'top', `${rect.y}px`);
    setStyle(container, 'width', `${rect.width}px`);
    setStyle(container, 'height', `${rect.height}px`);
  }

  return {
    setVisible,
    layout,
    get visible(): boolean {
      return isVisible;
    },
  };
}
